module.exports = __webpack_public_path__ + "img/39_48.9b5b0f9e.png";